import { z } from 'zod'
import { PAYMENT_METHODS } from '@/features/expenses/types/expense.types'

/** Returns today's date as YYYY-MM-DD (browser local) for pre-filling the date field. */
export function getTodayDateString(): string {
  const now = new Date()
  const yyyy = now.getFullYear()
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const dd = String(now.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

const attachmentSchema = z.object({
  id: z.string(),
  url: z.string(),
  originalName: z.string(),
  mimeType: z.string(),
  size: z.number(),
})

export const expenseFormSchema = z.object({
  title: z.string().min(1, 'Title is required').max(120, 'Title is too long'),
  category: z.string().min(1, 'Category is required'),
  amount: z
    .number({ message: 'Amount must be a number' })
    .min(0.01, 'Amount must be at least 0.01'),
  currency: z.string().min(1, 'Currency is required'),
  date: z.string().min(1, 'Date is required'),
  paymentMethod: z.enum(PAYMENT_METHODS, { message: 'Payment method is required' }),
  description: z.string().max(1000, 'Description is too long').optional().or(z.literal('')),
  attachments: z.array(attachmentSchema),
})

export type ExpenseFormData = z.infer<typeof expenseFormSchema>
